// console.log("index.js")

import Vue from "vue";
import VueRouter from "vue-router";

const axios = require("axios");

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "NotFound",
  //   component: () =>
  //     import(/* webpackChunkName: "NotFound" */ "../views/404.vue"),
  // },
];

let router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// console.log("test")
const urlSekolah = window.location.host;
const urlParams = new URLSearchParams(window.location.search);
const qTemplate = urlParams.get("preview");

const setTheme = (theme) => {
  const routes = [
    {
      path: "/",
      name: "Home",
      component: () => import(`../views/${theme}/index.vue`),
    },
    {
      path: "/visi-misi",
      name: "visi-misi",
      component: () => import(`../views/${theme}/visi-misi.vue`),
    },
    {
      path: "/tujuan",
      name: "tujuan",
      component: () => import(`../views/${theme}/tujuan.vue`),
    },
    {
      path: "/sejarah",
      name: "sejarah",
      component: () => import(`../views/${theme}/sejarah.vue`),
    },
    {
      path: "/sambutan",
      name: "sambutan",
      component: () => import(`../views/${theme}/sambutan.vue`),
    },
    {
      path: "/jajaran",
      name: "jajaran",
      component: () => import(`../views/${theme}/jajaran.vue`),
    },
    {
      path: "/berita",
      name: "berita",
      component: () => import(`../views/${theme}/berita.vue`),
    },
    {
      path: "/kewirausahaan",
      name: "kewirausahaan",
      component: () => import(`../views/${theme}/kewirausahaan.vue`),
    },
    {
      path: "/kewirausahaan/detail-barang/:id",
      name: "kewirausahaan",
      component: () =>
        import(`../views/${theme}/kewirausahaan_detail_barang.vue`),
    },
    {
      path: "/kewirausahaan/toko/:id",
      name: "kewirausahaan",
      component: () =>
        import(`../views/${theme}/kewirausahaan_toko_penjual.vue`),
    },
    {
      path: "/berita-detail",
      name: "berita-detail",
      component: () => import(`../views/${theme}/berita-detail.vue`),
    },
    {
      path: "/jurusan",
      name: "jurusan",
      component: () => import(`../views/${theme}/jurusan.vue`),
    },
    {
      path: "/pengumuman",
      name: "pengumuman",
      component: () => import(`../views/${theme}/pengumuman.vue`),
    },
    {
      path: "/galeri",
      name: "galeri",
      component: () => import(`../views/${theme}/galeri.vue`),
    },
    {
      path: "/ekstra-kurikuler",
      name: "ekstra-kurikuler",
      component: () => import(`../views/${theme}/ekstra-kurikuler.vue`),
    },
    {
      path: "/postingan",
      name: "postingan",
      component: () => import(`../views/${theme}/postingan.vue`),
    },
    {
      path: "/postingan/detail/:id",
      name: "postingan-detail",
      component: () => import(`../views/${theme}/postingan_detail.vue`),
    },
    {
      path: "/ekstra-kurikuler-detail",
      name: "ekstra-kurikuler-detail",
      component: () => import(`../views/${theme}/ekstra-detail.vue`),
    },
    {
      path: "/jurusan-detail",
      name: "jurusan-detail",
      component: () => import(`../views/${theme}/jurusan-detail.vue`),
    },

    {
      path: "/buku-tamu",
      name: "buku-tamu",
      component: () => import(`../views/${theme}/buku-tamu.vue`),
    },
    {
      path: "/kontak",
      name: "kontak",
      component: () => import(`../views/${theme}/kontak.vue`),
    },
    {
      path: "/login",
      name: "login",
      component: () => import(`../views/${theme}/login.vue`),
    },
    {
      path: "/toko-saya",
      name: "toko-saya",
      component: () => import(`../views/${theme}/toko-saya.vue`),
    },

    // Template New
    {
      path: "/jurusan-detail/:id",
      name: "jurusan-detail",
      component: () =>
        import(`../views/${theme}/Jurusan/DetailJurusan/index.vue`),
    },
    {
      path: "/ekstra-kurikuler-detail/:id",
      name: "ekstra-kurikuler-detail",
      component: () =>
        import(
          `../views/${theme}/Ekstrakurikuler/DetailEkstrakurikuler/index.vue`
        ),
    },
    {
      path: "/berita-detail/:id",
      name: "berita-detail",
      component: () =>
        import(`../views/${theme}/Berita/DetailBerita/index.vue`),
    },
    {
      path: "/pengumuman-detail/:id",
      name: "pengumuman-detail",
      component: () =>
        import(`../views/${theme}/Pengumuman/DetailPengumuman/index.vue`),
    },
  ];
  router.addRoutes(routes);
};

console.log(qTemplate);

if (qTemplate) {
  setTheme(qTemplate);
} else {
  axios
    .get(process.env.VUE_APP_API_ENDPOINT + "/webschool/theme")
    .then((response) => {
      let theme = response.data.data.name;
      setTheme(theme);
    })
    .catch((error) => {
      console.log("===error", error);
    });
}

// function setTemplate(theme) {
//     const routes = [
//         {
//             path: '/',
//             name: 'Home',
//             component: () => import(`../views/${theme}/index.vue`)
//         },
//         {
//             path: '/visi-misi',
//             name: 'visi-misi',
//             component: () => import(`../views/${theme}/visi-misi.vue`)
//         },
//         {
//             path: '/tujuan',
//             name: 'tujuan',
//             component: () => import(`../views/${theme}/tujuan.vue`)
//         },
//         {
//             path: '/sejarah',
//             name: 'sejarah',
//             component: () => import(`../views/${theme}/sejarah.vue`)
//         },
//         {
//             path: '/sambutan',
//             name: 'sambutan',
//             component: () => import(`../views/${theme}/sambutan.vue`)
//         },
//         {
//             path: '/jajaran',
//             name: 'jajaran',
//             component: () => import(`../views/${theme}/jajaran.vue`)
//         },
//         {
//             path: '/berita',
//             name: 'berita',
//             component: () => import(`../views/${theme}/berita.vue`)
//         },
//         {
//             path: '/berita-detail',
//             name: 'berita-detail',
//             component: () => import(`../views/${theme}/berita-detail.vue`)
//         },
//         {
//             path: '/jurusan',
//             name: 'jurusan',
//             component: () => import(`../views/${theme}/jurusan.vue`)
//         },
//         {
//             path: '/pengumuman',
//             name: 'pengumuman',
//             component: () => import(`../views/${theme}/pengumuman.vue`)
//         },
//         {
//             path: '/galeri',
//             name: 'galeri',
//             component: () => import(`../views/${theme}/galeri.vue`)
//         },
//         {
//             path: '/ekstra-kurikuler',
//             name: 'ekstra-kurikuler',
//             component: () => import(`../views/${theme}/ekstra-kurikuler.vue`)
//         },
//         {
//             path: '/ekstra-kurikuler-detail',
//             name: 'ekstra-kurikuler-detail',
//             component: () => import(`../views/${theme}/ekstra-detail.vue`)
//         },
//         {
//             path: '/jurusan-detail',
//             name: 'jurusan-detail',
//             component: () => import(`../views/${theme}/jurusan-detail.vue`)
//         },
//         {
//             path: '/buku-tamu',
//             name: 'buku-tamu',
//             component: () => import(`../views/${theme}/buku-tamu.vue`)
//         },
//         {
//             path: '/kontak',
//             name: 'kontak',
//             component: () => import(`../views/${theme}/kontak.vue`)
//         },
//     ]
//     router.addRoutes(routes)
// }

export default router;
